import { Routes } from '@angular/router';
import {
  AuthGuardService as AuthGuard,
  NoAuthGuardService as NoAuthGuard,
} from '@yukawa/chain-main-angular-session';
import { LayoutComponent } from './layout/layout.component';
import { AuthSignOutComponent } from './comp/auth/sign-out/sign-out.component';

export const routes: Routes = [
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: '/locations' },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/feature.routes').then((m) => m.routes),
  },
  {
    path: 'sign-out',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: AuthSignOutComponent,
  },
  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    data: {
    },
    children: [
      {
        path: 'sign-in',
        loadChildren: () =>
          import('./comp/auth/sign-in/sign-in.routes')
      },
    ],
  },
];
